<template>
   <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <h1 class="h3 mb-4 text-gray-800">Faq</h1>

    <!-- Circle Buttons -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Modifier un faq</h6>
      </div>
      <div class="card-body">
        <FaqEditForm />
      </div>
    </div>
  </div>
</template>

<script>
import FaqEditForm from "@/components/faq/FaqEditForm";

export default {
  name: "EditFaq",
  components: { FaqEditForm },
};
</script>